import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-rules-terms-gulf',
  templateUrl: './rules-terms-gulf.component.html',
  styleUrls: ['./rules-terms-gulf.component.scss']
})
export class RulesTermsGulfComponent implements OnInit {

  constructor(public globalService:GlobalService) { }

  ngOnInit(): void {
  }

}
